/* Defines the autocomplete entity */
export class CommonAutoCompleteModel {
    UserId: number;
    LoginId: string;
}
